(function () {
  angular.module("akitabox.workOrder.myList", [
    "angular-storage",
    "ui.router",
    "akitabox.constants",
    "akitabox.core.router",
    "akitabox.core.services.workOrder",
    "akitabox.core.services.user",
    "akitabox.mobile.constants",
  ]);
})();
